import React, { FC } from 'react';
import styled from 'styled-components';
import { typography } from '@cld/typography';
import { Body } from './Body';
import { Sub } from './Sub';

const Root = styled.div`
  ${typography.xs.regular};
`;

export const Footer: FC = () => (
  <Root data-test="footer-container">
    <Body />
    <Sub />
  </Root>
);
